import BaseEntityService from "core/framework/BaseEntityService";
import env from "environment";

class PersonService extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/people"
    });
  }
}

const service = new PersonService();

export default service;
